export const toLoginPageviewTrackerContext = ({
  hashedUserId,
  authPartner,
  didResetPassword,
  timeToInteractive,
  experiment,
}) => {
  let context = {};

  if (hashedUserId) {
    context = {
      PropContextDimension1: 'welcome_login_page_improved',
      PropHashedUserIdLo: hashedUserId,
      PropAbtest: `${experiment.selectedVariantName}_${experiment.name}`,
    };
  } else if (authPartner) {
    context = {
      PropContextDimension1: 'welcome_login_page_oauth',
    };
  }

  if (didResetPassword) {
    context = {
      ...context,
      PropContextDimension1: 'welcome_login_page_recovery_password_success',
    };
  }

  if (timeToInteractive && timeToInteractive >= 0) {
    context = {
      ...context,
      PropTempVar: `welcome_${timeToInteractive}`,
    };
  }

  return context;
};

export default toLoginPageviewTrackerContext;
